import { IRest } from './rest.interface';

export interface IContractedCompanyAddress {
  road: string;
  house_number: string;
  city: string;
  state: string;
  suburb: string;
  postcode: string;
}


export interface IContractedCompanyContact {
  name: string;
  email?: string;
  phone?: string;
}

export class ContractedCompany implements IRest {
  className = 'Empresas Contratadas';

  id: string;
  workspaceId: string;

  corporateName: string;
  tradeName: string;
  cnpj: string;

  address: IContractedCompanyAddress;

  contacts: IContractedCompanyContact[] = [];

  createdAt: Date;
  updatedAt: Date;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  }

  Serialize() {
    const out = {
      id: this.id || undefined,
      workspaceId: this.workspaceId,

      corporateName: this.corporateName,
      tradeName: this.tradeName,
      cnpj: this.cnpj,

      address: this.address,
      contacts: this.contacts
    };

    return out;
  }

  Deserialize(data: any) {
    if (data) {
      this.id = data.id || '';
      this.workspaceId = data.workspaceId || '';

      this.corporateName = data.corporateName || '';
      this.tradeName = data.tradeName || '';
      this.cnpj = data.cnpj || '';

      this.address = data.address || {
        road: '',
        house_number: '',
        city: '',
        state: '',
        suburb: '',
        postcode: '',
      };

      this.contacts = data.contacts || [];

      this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date(2000, 1, 1);
      this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : new Date(2000, 1, 1);
    }

    return this;
  }
}
